// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as InsurancePlanCmp from "./InsurancePlanCmp.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as InsuranceRepoManager from "../../app/insurance-plan/repo/InsuranceRepoManager.bs.js";
import * as CircularLoader$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as InsuranceContentManager from "../content/InsuranceContentManager.bs.js";
import * as InsurancePlanStateMachine from "../state-manager/InsurancePlanStateMachine.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function InsuranceDashboard(Props) {
  var uuid = Props.uuid;
  var auth_token = Props.auth_token;
  var language = Props.language;
  var category = Props.category;
  var eligibility_status = Props.eligibility_status;
  var geo_region = Props.geo_region;
  var match = React.useReducer(InsurancePlanStateMachine.reducer, InsurancePlanStateMachine.initialState);
  var dispatch = match[1];
  React.useEffect((function () {
          if (!eligibility_status) {
            Curry._1(dispatch, /* FetchData */{
                  _0: {
                    TAG: /* Loading */0,
                    _0: undefined
                  }
                });
            var RepoInstance = InsuranceRepoManager.getRepo(undefined);
            ApiUtils$Catalyst.handleAPIRequest((function (param) {
                    return Curry._2(RepoInstance.fetchInsurancePlanDetails, uuid, auth_token);
                  }), (function (data) {
                    return Curry._1(dispatch, /* FetchData */{
                                _0: {
                                  TAG: /* Live */1,
                                  _0: data
                                }
                              });
                  }), (function (error) {
                    return Curry._1(dispatch, /* FetchData */{
                                _0: {
                                  TAG: /* Error */2,
                                  _0: error
                                }
                              });
                  }));
          }
          
        }), []);
  if (eligibility_status) {
    var content = InsuranceContentManager.InsurancePlanContentManager.execute(language, category, geo_region);
    return React.createElement("div", {
                className: "c-incentive-dashboard"
              }, React.createElement("div", undefined, React.createElement(InsurancePlanCmp.make, {
                        data: undefined,
                        content: content,
                        eligibility_status: eligibility_status,
                        geo_region: geo_region,
                        category: category
                      })));
  }
  var data = match[0].insurancePlan;
  if (typeof data === "number") {
    return null;
  }
  switch (data.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        var content$1 = InsuranceContentManager.InsurancePlanContentManager.execute(language, category, geo_region);
        return React.createElement("div", {
                    className: "c-incentive-dashboard"
                  }, React.createElement("div", undefined, React.createElement(InsurancePlanCmp.make, {
                            data: data._0,
                            content: content$1,
                            eligibility_status: eligibility_status,
                            geo_region: geo_region,
                            category: category
                          })));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: data._0
                  });
    
  }
}

var make = InsuranceDashboard;

export {
  make ,
  
}
/* react Not a pure module */
